module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/header-image-mobile-01-83d0dc0635459d479bfc230227132a1d.jpg";